import Vue from 'vue';
import Vuex, {StoreOptions} from 'vuex';
import {RootState} from './RootState';
import {authModule} from "./modules/authModule";
import {channelModule} from "@/store/modules/channelModule";
import {lockerModule} from "./modules/lockerModule";
import {locker2Module} from "./modules/locker2Module";
import {standaloneModule} from './modules/standaloneModule';
import {orderModule} from "@/store/modules/orderModule";
import {permissionsModule} from "@/store/modules/permissionsModule";
import {screensaverModule} from "@/store/modules/screensaverModule";
import {lockerCompanyModule} from "@/store/modules/lockerCompanyModule";
import {userModule} from "./modules/userModule";
import {usersPromotionModule} from "@/store/modules/user/usersPromotionModule";
import {userPermissionModule} from "@/store/modules/user/userPermissionModule";
import {settingsModule} from "@/store/modules/settingsModule";
import {serviceProviderModule} from "@/store/modules/serviceProviderModule";
import {translationModule} from "@/store/modules/settings/translationModule";
import {zonesModule} from "@/store/modules/settings/zonesModule";
import {courierModule} from "@/store/modules/courierModule";
import {lockerServiceProviderModule} from "@/store/modules/services/lockerServiceProviderModule";
import {serviceProviderUserModule} from "@/store/modules/serviceProviderUserModule";
import {imageUploaderModule} from "@/store/modules/imageUploaderModule";
import {webhookModule} from "@/store/modules/webhookModule";
import {lockerContractModule} from "@/store/modules/locker/lockerContractModule";
import {serviceProviderPromotionModule} from "@/store/modules/serviceProviderPromotionModule";
import {serviceProviderServiceModule} from "@/store/modules/serviceProviderServiceModule";
import {userImportModule} from "@/store/modules/userImportModule";
import {userDiffusionExpressModule} from "@/store/modules/userDiffusionExpressModule";
import {laLigaModule} from "@/store/modules/laLigaModule";
import {realtimeModule} from "@/store/modules/realtimeModule";
import {sshConnectionModule} from "@/store/modules/sshConnectionsModule";
import {serviceProviderMetricsModule} from "@/store/modules/serviceProviderMetricsModule";
import {communityModule} from "@/store/modules/communityModule";
import {invoiceModule} from "@/store/modules/invoiceModule";
import {businessClientModule} from "@/store/modules/businessClientModule";
import {routeModule} from "@/store/modules/routeModule";
import {productModule} from "@/store/modules/productModule";
import {helpdeskAccountsModule} from "@/store/modules/helpdeskAccountsModule";
import {helpdeskInboxModule} from "@/store/modules/helpdeskInboxModule";
import {helpdeskTicketsModule} from "@/store/modules/helpdeskTicketsModule";
import {helpdeskSpamModule} from "@/store/modules/helpdeskSpamModule";
import {helpdeskSentModule} from "@/store/modules/helpdeskSentModule";
import {helpdeskTicketTypesModule} from "@/store/modules/helpdeskTicketTypesModule";
import {helpdeskEmailTemplatesModule} from "@/store/modules/helpdeskEmailTemplatesModule";
import {helpdeskEmailSignaturesModule} from "@/store/modules/helpdeskEmailSignaturesModule";
import {helpdeskWhatsappModule} from "@/store/modules/helpdeskWhatsappModule";

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  modules: {
    authModule,
    channelModule,
    imageUploaderModule,
    laLigaModule,
    lockerModule,
    locker2Module,
    lockerContractModule,
    lockerServiceProviderModule,
    standaloneModule,
    orderModule,
    permissionsModule,
    productModule,
    realtimeModule,
    screensaverModule,
    lockerCompanyModule,
    serviceProviderModule,
    serviceProviderPromotionModule,
    serviceProviderServiceModule,
    serviceProviderUserModule,
    settingsModule,
    userModule,
    userImportModule,
    userDiffusionExpressModule,
    userPermissionModule,
    usersPromotionModule,
    translationModule,
    zonesModule,
    courierModule,
    webhookModule,
    serviceProviderMetricsModule,
    communityModule,
    invoiceModule,
    clientModule: businessClientModule,
    routeModule,
    helpdeskAccountsModule,
    helpdeskInboxModule,
    helpdeskTicketsModule,
    helpdeskSpamModule,
    helpdeskSentModule,
    helpdeskTicketTypesModule,
    helpdeskEmailTemplatesModule,
    helpdeskEmailSignaturesModule,
    helpdeskWhatsappModule,
    sshConnectionModule,
  }
};

export default new Vuex.Store<RootState>(store);
